export default "__VITE_ASSET__eiuQoR4D__"